import { useCallback, useMemo, useState } from 'react';

import { useAtomValue } from 'jotai';

import { useActivitySwings, useSwing } from '@queries';
import { activeUserSettingsAtom, activityIdAtom } from '@store';

export const useComparisonSwing = () => {
    const [openModal, setOpen] = useState(false);
    const toggleModal = useCallback(() => setOpen((prev) => !prev), []);
    const { comparisonSwingId } = useAtomValue(activeUserSettingsAtom);

    const { data: swing } = useSwing(comparisonSwingId || '');
    const activityId = useAtomValue(activityIdAtom);
    const { data: activitySwings = [] } = useActivitySwings(activityId);

    const comparisonLabel = useMemo((): string => {
        if (!swing) return 'Compare';
        if (swing.name) {
            return swing.name;
        }
        const activitySwingIndex = activitySwings.findIndex(({ uuid }) => uuid === comparisonSwingId);
        const activitySwingNumber = activitySwingIndex !== -1 ? activitySwings[activitySwingIndex].number : 0;

        if (activitySwingNumber) {
            return `Swing ${activitySwingNumber}`;
        }

        return 'Untitled swing';
    }, [activitySwings, comparisonSwingId, swing]);

    return {
        comparisonLabel,
        openModal,
        toggleModal,
    };
};
